import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { finishExam, getSchoolName, leaveExam, previewExam } from "../../../assets/api/userActions";
import { PreviewCountdown } from "../../../components/countDown/countDown";
import TestQuestion from "../../../components/testQuestion";
import DescriptiveQuestion from "../../../components/descriptiveQuestion";
import Swal from "sweetalert2";

import { ReactComponent as Exit } from "../../../assets/icons/exit.svg";
import { ReactComponent as Refresh } from "../../../assets/icons/RightSquare.svg";

import {
    checkMatchQuestionMixed,
    getQuizTypeLabel,
    isTestQuestion,
} from "../../../assets/utils/utils";
import Loading from "../../../components/loading/loading";

import classes from "../../../App.module.scss";
import ExitModal from "../../../components/modal/exitModal";
import TestCheckboxPreviewButtons from "../../../components/previewAnswerButtons/testCheckboxButtons/testCheckboxPreviewButtons";
import PreviewUploadButtons from "../../../components/previewAnswerButtons/descriptiveUploadButtons/previewUplaodButton";

function MixedPreview() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const params = useParams();

    const [activeBtn, setActiveBtn] = useState(null);
    const [examData, setExamData] = useState();
    const [examDataAttempt] = useState([]);
    const [userAnswered, setUserAnswered] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [schoolName, setSchoolName] = useState("");
    const [totalTime] = useState(0);
    const [, setAnswered] = useState();
    const [unAnswered, setUnAnswered] = useState();

    const [exitConfirm, setExitConfirm] = useState(false);
    const [isLeave, setIsLeave] = useState(false);

    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const paramsToken = searchParams.get("_token");
        if (!paramsToken) navigate(-1);
        const data = await previewExam(params.quiz, paramsToken);
        if (data?.status !== "joined") {
            let a = data?.message;
            a = a.split("{").join("");
            a = a.split("}").join("");
            if (a.includes("date")) {
                a = a.replace("date", data?.date);
            }
            if (a.includes("time")) {
                a = a.replace("time", data?.time);
            }
            Swal.fire({
                icon: "error",
                title: `${a}`,
            });
            setTimeout(() => {
                navigate("/quiz/join/" + params.quiz);
            }, "1000");
        }

        data?.attempt?.answers && setUserAnswered(checkMatchQuestionMixed(data.quiz, data.attempt));
        setExamData(data);
        setUnAnswered(data?.quiz.number_of_question);
        setIsLoading(false);
        return data.quiz.title;
    }, [params.quiz, navigate, searchParams]);

    useEffect(() => {
        const examTitle = fetchData();
        fetchSchoolName();
        examTitle.then((res) => (document.title = `پیشنمایش آزمون ${res}`));
    }, [fetchData, fetchSchoolName]);

    const onFinishHandler = async (e) => {
        const res = await finishExam(e);
        if (res.status === "success-finish") {
            navigate("/quiz/finish");
        } else {
            Swal.fire({
                icon: "warning",
                title: `${res.message}`,
            });
        }
    };

    const onLeaveHandler = async (e) => {
        const res = await leaveExam(e);
        if (res.status === "success-leave") {
            navigate("/quiz/join/" + params.quiz);
        } else {
            Swal.fire({
                icon: "warning",
                title: `${res.message}`,
            });
        }
    };

    const onConfirm = () => {
        if (isLeave) {
            onLeaveHandler(examDataAttempt.id);
        } else {
            onFinishHandler(examDataAttempt.id);
        }
    };

    const onClose = () => {
        setExitConfirm((prev) => !prev);
    };

    const answerResHandler = (data) => {
        setAnswered(data.answered_questions);
        setUnAnswered(data.unanswered_questions);
    };

    const activeBtnHandler = (index) => {
        setActiveBtn(index);
    };

    const nullingActiveBtnHandler = () => {
        setActiveBtn(null);
    };

    const renderAnswerSheetItem = (data) => {
        if (isTestQuestion(data)) {
            return (
                <TestCheckboxPreviewButtons
                    key={data.id}
                    id={data.id}
                    examDataAttempt={examDataAttempt}
                    userAnswered={userAnswered}
                    answerResHandler={answerResHandler}
                    options={data.options}
                    score={data.score}
                    quNo={data.question_number}
                    isRank={examData.quiz.test_type}
                    quizType={examData.quiz.type}
                />
            );
        }

        return (
            <PreviewUploadButtons
                key={data.id}
                index={data.id}
                quNo={data.question_number}
                options={data.options}
                score={data.score}
                activeBtn={activeBtn}
                activeBtnHandler={activeBtnHandler}
                userAnswered={userAnswered}
                answerResHandler={answerResHandler}
                nullingActiveBtnHandler={nullingActiveBtnHandler}
            />
        );
    };

    const renderQuestion = (data) => {
        if (isTestQuestion(data)) {
            return (
                <TestQuestion
                    key={data.id}
                    data={data}
                    id={data.id}
                    options={data.options}
                    quNo={data.question_number}
                    body={data.body}
                    score={data.score}
                    imageURL={data.image}
                    audioURL={data?.voice}
                    question={data}
                    isRank={examData.quiz.test_type}
                    quizType={examData.quiz.type}
                />
            );
        }

        return (
            <DescriptiveQuestion
                key={data.id}
                data={data}
                id={data.id}
                quNo={data.question_number}
                body={data.body}
                score={data.score}
                imageURL={data.image}
                audioURL={data?.voice}
                question={data}
            />
        );
    };

    const answerSheetClassName = examData?.quiz?.questions?.some((q) => !isTestQuestion(q))
        ? classes.uploadAnswersSheet
        : classes.answerSheet;

    return (
        <div className={`${classes.appContainer} ${classes.smSizeAppContainer}`}>
            {!isLoading ? (
                examData && (
                    <div className={classes.container}>
                        <header className={classes.timeRemainedContainer} style={{ display: "grid" }}>
                            {exitConfirm && (
                                <ExitModal onClose={onClose} leave={isLeave} onConfirm={onConfirm} />
                            )}
                            <div className={classes.headerBox}>
                                <div className={classes.buttonContainer}>
                                    <p
                                        onClick={() => {
                                            setIsLeave(false);
                                            setExitConfirm(true);
                                        }}
                                    >
                                        اتمام پیشنمایش
                                    </p>
                                    {examData.quiz.leave ? (
                                        <p
                                            onClick={() => {
                                                setIsLeave(true);
                                                setExitConfirm(true);
                                            }}
                                        >
                                            ترک آزمون
                                        </p>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                                <PreviewCountdown totalTime={totalTime} />
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData.quiz.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill="#fff" width="15px" height="15px" />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li>{`نام کاربر : ${"کاربر"}`}</li>
                                        <li>
                                            {`مدت آزمون : ${
                                                examData?.quiz?.duration
                                                    ? examData?.quiz?.duration + " دقیقه "
                                                    : "نامحدود"
                                            }`}
                                        </li>
                                        <li>{`نوع آزمون : ${getQuizTypeLabel(examData.quiz.type)}`}</li>
                                        {examData.quiz.type === "mixed" || examData.quiz.test_type === "score" ? (
                                            <li>{`نمره کل : ${examData.quiz.total_score}`}</li>
                                        ) : (
                                            <li>
                                                {`ضریب منفی : ${
                                                    examData.quiz.negative_point === null
                                                        ? "ندارد"
                                                        : examData.quiz.negative_point?.replace("/", " به ")
                                                }`}
                                            </li>
                                        )}
                                        <li>{`تعداد سوالات : ${examData.quiz.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : 0`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>
                                            {`پاسخ داده نشده : ${unAnswered === null ? 0 : unAnswered}`}
                                        </p>
                                    </div>
                                </div>
                                <div className={answerSheetClassName}>
                                    <ol>{examData.quiz?.questions?.map((data) => renderAnswerSheetItem(data))}</ol>
                                </div>
                            </div>

                            <section className={classes.questionSection}>
                                <div className={classes.questionSection_header}>
                                    <h2>سوالات آزمون</h2>
                                    <div className={classes.reloadBtn} onClick={() => window.location.reload()}>
                                        <p>بارگذاری مجدد</p>
                                        <div id={classes.refreshIcon}>
                                            <Refresh />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.questionContainer}>
                                    {examData.quiz?.questions?.map((data) => renderQuestion(data))}
                                </div>
                            </section>
                        </main>
                    </div>
                )
            ) : (
                <Loading />
            )}
        </div>
    );
}

export default MixedPreview;
